import {
  TwilioBusinessRegistrationIdentifier,
  TwilioBusinessType,
} from 'constants/twilio/twilioCustomerProfile';
import { CampaignProfile } from 'types/twilio/campaignProfile';
import { CreateTwilioCustomerProfileOptions } from 'types/twilio/twilioCustomerProfile';

interface BuildDefaultCustomerProfileOptionsArgs {
  savedCampaignProfile: CampaignProfile | null | undefined;
  businessName: string;
  businessWebsiteUrl: string;
}

export const buildDefaultCustomerProfileOptions = ({
  savedCampaignProfile,
  businessName,
  businessWebsiteUrl,
}: BuildDefaultCustomerProfileOptionsArgs): CreateTwilioCustomerProfileOptions => ({
  legalBusinessName: savedCampaignProfile?.legalBusinessName ?? businessName,
  businessWebSite: savedCampaignProfile?.businessWebSite ?? businessWebsiteUrl,
  businessType: savedCampaignProfile?.businessType ?? TwilioBusinessType.PARTNERSHIP,
  businessRegistrationIdentifier:
    savedCampaignProfile?.businessRegistrationIdentifier ??
    TwilioBusinessRegistrationIdentifier.EIN,
  businessRegistrationNumber: savedCampaignProfile?.businessRegistrationNumber ?? '',
});
